import { Component, HostListener, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Observable, of } from "rxjs";
import { catchError, filter, map } from 'rxjs/operators';
import { CompanyService } from "src/app/core/services/company/company.service";
import { environment } from '../environments/environment';
import { IContribuyente } from "./core/models/business-information/ibusiness-information";
import { AuthResponse } from './core/models/user/ciam-auth';
import { CiamUser } from './core/models/user/ciam-user';
import { IUser } from './core/models/user/user';
import { FormatDocumentTypePipe } from "./core/pipes/format-documant-type/format-document-type.pipe";
import { LocalStorageService } from "./core/services/local-storage/local-storage.service";
import { SesionStorageService } from './core/services/sesion-storage/sesion-storage.service';
import { GlobalService } from './core/services/global/global.service';

declare var dataLayer;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  isMobile: boolean = false;
  lastChange: string = '';
  title = 'Portal Empresas';
  mostrarContenido = false;
  public business: IContribuyente;
  public companyData: IContribuyente;
  public $companyData: Observable<IContribuyente>;

  constructor(
    private _company: CompanyService,
    private _router: Router,
    private formatDocumentTypePipe: FormatDocumentTypePipe,
    private _STORAGE: LocalStorageService,
    private _sesionStorage: SesionStorageService,
    private globalService: GlobalService
  ) { }

  ngOnInit() {
    this.sendHitGoogleAnalytics();

    this.business = this._STORAGE.parseItem('businessInformation');
    if (this.business !== null) {
      const docType = `${this.formatDocumentTypePipe.transform(this.business.tipoDocumento)}`;
      const docNumber = `${this.business.numeroDocumento}`;
      const state = `1`;
      const isRectificable = true;
    }

    this.checkWindowSize();
    this.globalService.validarVersion();
  }

  sendHitGoogleAnalytics() {
    this._router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map((event: NavigationEnd) => {
        dataLayer.push({
          event: 'pageview',
          page: {
            page: event.url
          }
        });
      })
    ).subscribe();
  }

  get apiKey(){
    return environment.CIAM_API_KEY;
  }

  get typeMarketing(){
    return environment.CIAM_TYPE_MARKETING;
  }

  get varUserData(){
    return environment.CIAM_VAR_USERDATA;
  }

  get screenPrefix(){
    return environment.CIAM_API_PREFIX;
  }

  get cdnUrl(){
    return environment.CIAM_API_CDN_URL;
  }

  get countAuth(){
    return environment.CIAM_COUNT_AUTH;
  }

  get urlAuthenticationCiam(){
    return environment.CIAM_URL_AUTHENTICATION_CIAM;
  }

  redirectUrl(redirect: boolean) {
    if (redirect) {
      setTimeout( () => {
        console.log('login ciam');
        this.loadCIAM();
      }, 1000);
    } else{
      console.log('logout ciam');
    //  this._router.navigate(['/login']);
    }
  }

  loadCIAM(){
      let dataCompany = this._sesionStorage.getItemJSON(environment.CIAM_VAR_ORGANIZATION);
      let dataSessionAut:AuthResponse = this._STORAGE.getItemJSON(environment.CIAM_VAR_AUTHDATA);
      let dataSession:CiamUser = this._sesionStorage.getItemJSON(environment.CIAM_VAR_USERDATA);
      if(dataSession){
        console.log('Usuario autenticado.');
        let userloggedin: IUser = {};
        const numeroDocumento = dataCompany.info.numeroDocumento[0];
        const tpIdentificacion = this.transformarIdentificacion(dataCompany.info.tpIdentificacion[0]);

        userloggedin.docNumberCompany = numeroDocumento;
        userloggedin.docTypeCompany = tpIdentificacion;

        console.log(dataSessionAut.business.docNumberCompany);

        userloggedin.docNumberCustomer = dataSessionAut.business.docNumberCustomer;
        userloggedin.docTypeCustomer = dataSessionAut.business.docTypeCustomer;

        userloggedin.firstName= dataSessionAut.business.firstName;
        userloggedin.lastName= dataSessionAut.business.lastName;
        userloggedin.fullName= dataSessionAut.business.fullName;
        userloggedin.telephoneNumber= dataSessionAut.business.telephoneNumber;
        userloggedin.email= dataSessionAut.business.email;

        userloggedin.checkDigit =  this.calcularDigitoVerificacion(userloggedin.docNumberCompany, userloggedin.docTypeCompany);

        userloggedin.timeSession= dataSessionAut.business.timeSession;
        userloggedin.tokenId= dataSessionAut.business.tokenId;


        this._STORAGE.setItemJSON( environment.LOCAL_STORAGE.USER_LOGGED_IN, userloggedin);
        this._STORAGE.setItem( environment.LOCAL_STORAGE.AUTHORIZATION_TOKEN, dataSessionAut.access_token);
        this._STORAGE.setItem( environment.LOCAL_STORAGE.LOGIN_USER_TOKEN, this._STORAGE.getItemString(environment.CIAM_VAR_USERDATA));
        this.getBusinnessInformation();
      }
  }

  getCiamAuthInfo() {
    return this._STORAGE.parseItem<AuthResponse>(environment.CIAM_VAR_AUTHDATA);
  }

  redirigirATablero() {
    const baseUrl = window.location.origin;
    const redirectPath = environment.URL_CONTEXT + '/#/';
    const fullRedirectUrl = baseUrl + redirectPath;

    window.location.href = fullRedirectUrl;
  }

  getBusinnessInformation() {
    console.log('getBusinnessInformation');
    let userloggedin: IUser = this._STORAGE.getItemJSON(environment.LOCAL_STORAGE.USER_LOGGED_IN);
    this._company
      .getBusinnessInformation(
        userloggedin.docTypeCompany,
        userloggedin.docNumberCompany,
        userloggedin.checkDigit
      )
      .pipe(
        map((response: any) => {
          this.companyData = response.body.data[0].contribuyente;
          this._company.setBusinnessInformation(this.companyData);
          this.$companyData = this._company.getBusinnessInformationObs();
          this._STORAGE.stringifyItem(
            environment.LOCAL_STORAGE.BUSINESS_INFORMATION,
            this.companyData
          );
          this.mostrarContenido = true;
          this.redirigirATablero();
        }),
        catchError((error: Error) => {
          console.error('Error al obtener la información de la empresa:', error.message);
          this.mostrarContenido = true;
          this.redirigirATablero();
          return of(null);
        })
      )
      .subscribe();
  }

  handleStorageChange() {
    console.log('handleStorageChange');
    setTimeout( () => {
      console.log('handleStorageChange start');
      let userloggedin: IUser = this._STORAGE.getItemJSON(environment.LOCAL_STORAGE.USER_LOGGED_IN);
      let dataSession:CiamUser = this._sesionStorage.getItemJSON(environment.CIAM_VAR_USERDATA);
      if(dataSession){
        if(userloggedin){

        }else{
          if(this.checkIfDialogIsVisible() === false){
            window.location.reload();
            console.log('Redireccionar');
          }
        }

      }
    }, 3000);
  }

  checkIfDialogIsVisible(): boolean {
    const element = document.querySelector('.gigya-screen-dialog-main');
    if (element) {
      const style = window.getComputedStyle(element);
      const isVisible = style.display !== 'none' && style.visibility !== 'hidden';
      console.log('¿Es visible?:', isVisible);
      return isVisible;
    }

    return false;
  }


   transformarIdentificacion(tipoIdentificacion) {
    switch(tipoIdentificacion) {
        case 'NI':
            return '1';
        case 'CC':
            return '2';
        case 'CE':
            return '3';
        case 'TI':
            return '4';
        case 'RC':
            return '5';
        case 'CD':
            return '6';
        case 'PA':
            return '7';
        case 'PE':
            return '8';
        case 'PT':
            return '9';
        default:
            return '0';
    }
}


calcularDigitoVerificacion(docNumber: string, docType: string) {
  if(docType === '1'){
  // Verificar si el docNumber es '1' y tiene una longitud de 10
    if (docNumber.length === 10) {
      const ultimoCaracter = docNumber.charAt(docNumber.length - 1);
      // Aquí podrías hacer algo con el último carácter si es necesario
      return ultimoCaracter;
    }

    // Si no es el caso, calcular el dígito de verificación
   return this.calcularDV(docNumber);
  }

  return '';
}

calcularDV(nit: any): string {
  // Se limpia el Nit
  nit = nit.replace(/\s/g, ''); // Espacios
  nit = nit.replace(/,/g, ''); // Comas
  nit = nit.replace(/\./g, ''); // Puntos
  nit = nit.replace(/-/g, ''); // Guiones

  const vpri = new Array(16);
  let z = nit.length;

  vpri[1] = 3;
  vpri[2] = 7;
  vpri[3] = 13;
  vpri[4] = 17;
  vpri[5] = 19;
  vpri[6] = 23;
  vpri[7] = 29;
  vpri[8] = 37;
  vpri[9] = 41;
  vpri[10] = 43;
  vpri[11] = 47;
  vpri[12] = 53;
  vpri[13] = 59;
  vpri[14] = 67;
  vpri[15] = 71;

  let x = 0;
  let y = 0;

  for (let i = 0; i < z; i++) {
    y = nit.substr(i, 1);
    x += y * vpri[z - i];
  }

  y = x % 11;
  let dv =  y > 1 ? 11 - y : y;
  return dv.toString();
}

@HostListener("window:resize", ["$event"])
onResize(event) {
  this.checkWindowSize();
}

checkWindowSize() {
  this.isMobile = window.innerWidth <= 768;
}


}
